import { render } from "./concierge-only-access.vue?vue&type=template&id=6a8fbeea&scoped=true"
import script from "./concierge-only-access.vue?vue&type=script&lang=js"
export * from "./concierge-only-access.vue?vue&type=script&lang=js"

import "./concierge-only-access.vue?vue&type=style&index=0&id=6a8fbeea&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a8fbeea"]])

export default __exports__